import Collapse from '@material-ui/core/Collapse';
import MenuList from '@material-ui/core/MenuList';
import PreseasonIcon from '@material-ui/icons/AddShoppingCart';
import ProgramIcon from '@material-ui/icons/Assignment';
import CoOpIcon from '@material-ui/icons/AttachMoney';
import FinanceIcon from '@material-ui/icons/CreditCard';
import LinkIcon from '@material-ui/icons/Link';
import CashDiscountsIcon from '@material-ui/icons/MoneyOff';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ReceiptIcon from '@material-ui/icons/ReceiptOutlined';
import * as React from 'react';
import { HasPermissions } from '../../components/HasPermissions';
import { useMiaSelector } from '../../components/hooks';
import { LeftNavHeader } from '../../components/LeftNavHeader';
import { isItOverriddenByType } from '../../ducks/auth';
import { NavTypes, NavUrls } from '../layoutConstants';
import { MenuLink } from '../MenuLink';

interface IFinanceMenuProps {
  collapsed: boolean;
  menuClassName: string;
  navType: NavTypes;
  onExpandClick: (navType: NavTypes) => any;
  onNavClick: () => any;
  currentLocation: string;
}

let FinanceMenu: React.FunctionComponent<IFinanceMenuProps> = ({
  collapsed,
  menuClassName,
  onExpandClick,
  onNavClick,
  navType,
  currentLocation
}) => {
  const isNavItOverridden = useMiaSelector(state => isItOverriddenByType(state, 'finance'));

  React.useEffect(() => {
    if (currentLocation.includes('finance') || currentLocation.includes('newDealer')) {
      onExpandClick('finance');
    }
  }, []);

  return (
    <HasPermissions type="finance">
      <LeftNavHeader
        collapsed={collapsed}
        navType={navType}
        onExpandClick={onExpandClick}
        icon={FinanceIcon}
        title="Finance"
        hasWarningColor={isNavItOverridden}
      />
      <Collapse component="li" in={collapsed} timeout="auto" unmountOnExit>
        <MenuList disablePadding>
          <MenuLink
            icon={<CoOpIcon />}
            to={NavUrls.financeCoOpRequests}
            label="Co-Op"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={currentLocation === NavUrls.financeCoOpRequests}
          />
          <MenuLink
            icon={<PersonAddIcon />}
            to={NavUrls.salesNewDealer}
            label="New Dealer"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={currentLocation === NavUrls.salesNewDealer}
          />
          <MenuLink
            icon={<ProgramIcon />}
            to={NavUrls.financePrograms}
            label="Programs"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={currentLocation === NavUrls.financePrograms}
          />
          <MenuLink
            icon={<PreseasonIcon />}
            to={NavUrls.financePreseason}
            label="Pre-Season"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={currentLocation === NavUrls.financePreseason}
          />
          <MenuLink
            icon={<CashDiscountsIcon />}
            to={NavUrls.financeCashDiscounts}
            label="Cash Discounts"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={currentLocation === NavUrls.financeCashDiscounts}
          />
          {false && (
            <MenuLink
              icon={<ReceiptIcon />}
              to={NavUrls.financePaymentTerms}
              label="Payment Terms"
              menuClassName={menuClassName}
              onNavClick={onNavClick}
              isActive={currentLocation === NavUrls.financePaymentTerms}
            />
          )}
          <MenuLink
            icon={<LinkIcon />}
            to={NavUrls.financeLinks}
            label="Links"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={currentLocation === NavUrls.financeLinks}
          />
        </MenuList>
      </Collapse>
    </HasPermissions>
  );
};

FinanceMenu = React.memo<IFinanceMenuProps>(FinanceMenu);
export { FinanceMenu };
